import { markUpdatePending } from '@/lib/deployWatcher';

// Inline text for a dialog whose own lazy import failed (Import1040Dialog).
// It is NOT a toast: a failed chunk kills one screen, not the app, so the
// message belongs inside the thing that broke. The corner-of-the-screen
// version is gone — see installStaleDeployListener below.
export const STALE_DEPLOY_MESSAGE =
  'TaxGenie updated while this tab was open, so this step could not load. Click "Update ready — reload" at the top of the screen, then try again. Nothing you entered is lost.';

// There is no spec'd wording for a failed dynamic import — every browser
// engine writes its own. Match all known phrasings:
//   Chrome/Edge: "Failed to fetch dynamically imported module: <url>"
//   Firefox:     "error loading dynamically imported module: <url>"
//   Safari:      "Importing a module script failed."
// plus the generic module-script and chunk-load variants.
const STALE_CHUNK_RE =
  /dynamically imported module|Importing a module script failed|Failed to load module script|ChunkLoadError|Loading chunk \S+ failed/i;

export function isStaleChunkError(message: string): boolean {
  return STALE_CHUNK_RE.test(message);
}

// Vite dispatches `vite:preloadError` on window whenever a lazy chunk fails to
// load, regardless of browser — no message-text sniffing involved. One
// listener covers every dynamic import in the app.
//
// This used to raise a permanent red toast telling the advisor to press
// Ctrl+Shift+R. It was the wrong control in every way (Drew, 2026-09-22):
// destructive colour for one dead screen rather than a dead app, no close
// button, infinite duration, and keyboard instructions instead of a button.
// It was also actively wrong mid-impersonation, where the app deliberately
// refuses to auto-reload because that drops the sandbox, while the toast sat
// in the corner telling you to reload anyway.
//
// The header pill is the one update control. A 404'd chunk is proof the build
// moved on, so this hands that fact to the deploy watcher and the pill appears
// exactly as it does for a polled detection. The advisor picks the moment.
export function installStaleDeployListener(): void {
  window.addEventListener('vite:preloadError', () => {
    markUpdatePending();
  });
}
